import React from 'react';
import { shape, string, func, oneOf, bool } from 'prop-types';
import { Container, Link, ImageContent, LinkImage, TextComponent } from './HotLink.styles';

const HotLink = ({
  item,
  onClick,
  directionType,
  imgLazyLoading
}) => {
  const {
    link,
    image,
    text,
    borderColor
  } = item;
  return /*#__PURE__*/React.createElement(Link, {
    href: link,
    onClick: e => onClick(e, item),
    "data-testid": "hotlink-link",
    borderColor: borderColor
  }, /*#__PURE__*/React.createElement(Container, {
    directionType: directionType,
    borderColor: borderColor,
    "data-testid": `title-${text}`
  }, /*#__PURE__*/React.createElement(ImageContent, null, /*#__PURE__*/React.createElement(LinkImage, {
    alt: text,
    src: image,
    lazy: imgLazyLoading
  })), /*#__PURE__*/React.createElement(TextComponent, null, text)));
};

HotLink.defaultProps = {
  item: {},
  onClick: () => {},
  directionType: 'row',
  imgLazyLoading: true
};
process.env.NODE_ENV !== "production" ? HotLink.propTypes = {
  item: shape({
    link: string,
    image: string,
    text: string
  }),
  directionType: oneOf(['row', 'column']),
  borderColor: string,
  imgLazyLoading: bool,
  onClick: func
} : void 0;
export default HotLink;